import { render, staticRenderFns } from "./AuthDep.vue?vue&type=template&id=cbfee1e6&scoped=true"
import script from "./AuthDep.vue?vue&type=script&lang=js"
export * from "./AuthDep.vue?vue&type=script&lang=js"
import style0 from "./AuthDep.vue?vue&type=style&index=0&id=cbfee1e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfee1e6",
  null
  
)

export default component.exports